
      var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCallIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 20,
  height: 20,
  rx: 10,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.963 9.028a6.43 6.43 0 0 1-2.417 3.435.604.604 0 0 1-.595.06l-2.1-.922a.61.61 0 0 0-.58.048l-3.25 2.126a.608.608 0 0 0-.25.686 3.66 3.66 0 0 0 4.13 2.517c5.638-.994 9.402-6.37 8.408-12.008a3.66 3.66 0 0 0-3.777-3.02.608.608 0 0 0-.56.47l-.887 3.785a.61.61 0 0 0 .15.556l1.584 1.688a.605.605 0 0 1 .144.579Z",
  fill: "var(--theme-light, #f9f3fb)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.244,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"21\" height=\"20\" viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"0.5\" width=\"20\" height=\"20\" rx=\"10\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9632 9.02803C12.5648 10.4113 11.7137 11.6209 10.5462 12.4631C10.3721 12.5866 10.1458 12.6091 9.95076 12.5222L7.85056 11.6005C7.66185 11.5176 7.44408 11.5357 7.27163 11.6486L4.02159 13.7752C3.79462 13.9227 3.69254 14.2025 3.77123 14.4615C4.31833 16.2199 6.08693 17.2978 7.90052 16.9781C13.5385 15.984 17.3031 10.6075 16.309 4.96952C15.9891 3.15597 14.3714 1.86268 12.5319 1.94998C12.2616 1.96462 12.0336 2.15624 11.9726 2.41996L11.085 6.20465C11.0384 6.40348 11.0944 6.61246 11.2342 6.76132L12.8194 8.4492C12.9658 8.60342 13.0204 8.82324 12.9632 9.02803Z\" fill=\"var(--theme-light, #f9f3fb)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.24444\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/call-icon.d577835f83910b1581804f3b9f2a06b6.svg"),
        {
          React: SvgCallIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      